<template>
  <div>
    <center>
      <b-tabs style="background-color: transparent !important">
        <b-tab
          title="service Facture Non Payé  OKBA "
          style="margin-top: 31px; background-color: transparent !important"
        >
          <div class="container-fluid" style="height: 65px">
            <div class="text-center" style="margin-top: -33px !important">
              <b-button variant="info" style="font-size: 15px">
                Total
                <b-badge variant="light">{{
                  filteredFactureservices.length
                }}</b-badge>
              </b-button>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="SelectRegion"
                    required
                    @change="facture_ser_okba_paye(selectedMois.Month)"
                    v-model="selectedMois.Month"
                  >
                    <option value disabled selected>Mois</option>
                    <option
                      v-for="(annUsers, index) in moezMois"
                      :value="annUsers.id"
                      :key="'i' + index"
                    >
                      {{ annUsers.text }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="SelectRegion"
                    required
                    @input="facture_ser_okba_paye(selectedClient.year)"
                    v-model="selectedClient.year"
                  >
                    <option value disabled selected>Année</option>
                    <option
                      v-for="(annUsers, index) in moezAnnee"
                      :value="annUsers.id"
                      :key="'i' + index"
                    >
                      {{ annUsers.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <input
                    class="form-control personalise"
                    placeholder="Recherche ..."
                    type="text"
                    v-model="search"
                  />
                </div>
              </div>
            </div>

            <div class="table-responsive" style="border: 1px solid #f5a623">
              <table class="table table-white">
                <thead>
                  <tr>
                    <!--  <th scope="col">#</th> -->

                    <th scope="col">Num F</th>

                    <!-- <th scope="col">Chouffeur</th> -->

                    <th scope="col">Date</th>

                    <th scope="col">Payement</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="user in filteredFactureservices"
                    v-bind:key="user.id"
                  >
                    <td>
                      {{ user.id }}
                    </td>

                    <!-- <td v-text="user.nom_chouffeur"></td> -->

                    <td>{{ user.date }}</td>
                    <b-badge style="color: #fff; background-color: #f10735">
                      {{ user.paye }}
                    </b-badge>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </center>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";
import _ from "lodash";
export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      search: "",
      listes_service: [],
      selected: [],
      get_societe_id_mise: {},
      verif: false,
      selectedOptionId: "",
      moezMois: [
        { id: 1, text: "Janvier" },
        { id: 2, text: "Février" },

        { id: 3, text: "Mars" },
        { id: 4, text: "Avril" },
        { id: 5, text: "Mai" },
        { id: 6, text: "Juin" },

        { id: 7, text: "Juillet" },
        { id: 8, text: "Août" },

        { id: 9, text: "Septembre" },
        { id: 10, text: "Octobre" },
        { id: 11, text: "Novembre" },
        { id: 12, text: "Décembre" },
      ],
      moezAnnee: [
        { id: 2020, text: "2020" },
        { id: 2021, text: "2021" },
        { id: 2022, text: "2022" },

        { id: 2023, text: "2023" },
        { id: 2024, text: "2024" },
        { id: 2025, text: "2025" },
        { id: 2026, text: "2026" },

        { id: 2027, text: "2027" },
        { id: 2028, text: "2028" },
      ],
      anneeUsers: [2020, 2021, 2022, 2024],
      moisUsers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

      yearSystem: new Date().getFullYear(),
      moisSystem: new Date().getMonth() + 1,
      selectedMois: {
        Month: new Date().getMonth() + 1,
      },

      selectedClient: {
        year: new Date().getFullYear(),
      },
      listes_facture_service: [],
      selected: [],
      q: "",
      /* ************************** */

      idsImprimer: [],
      select: "",
      all_select: false,
    };
  },

  created() {
    this.facture_ser_okba_paye();
    this.fetchsearch();
  },

  computed: {
    filteredFactureservices() {
      return this.listes_facture_service;
    },

    filteredservices: function () {
      if (Array.isArray(this.listes_facture_service)) {
        return this.listes_facture_service.filter((pack) => {
          return pack.id.match(this.search) || pack.date.match(this.search);
        });
      }
    },
  },

  methods: {
    keywords() {
      return this.search.split(" ");
    },
    facture_ser_okba_paye() {
      axios
        .get(
          `${apiDomain}/api/get_facture_okba_non_paye/${this.selectedMois.Month}/${this.selectedClient.year}`
        )
        .then((response) => {
          this.listes_facture_service = response.data;
          //this.count_service = response.data.count_service;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    facture_ser_okba_paye___() {
      fetch(`${apiDomain}/api/get_facture_okba_paye`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.data;
        })
        .catch((err) => console.log(err));
    },
    fetchsearch() {
      if (this.q.length > 1) {
        axios
          .get(`${apiDomain}/api/get_facture/` + this.q)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      } else {
        axios
          .get(`${apiDomain}/api/get_facture`)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      }
    },
    searchUnit: _.debounce(function () {
      axios
        .get(`${apiDomain}/api/search_num_fac/` + this.search)
        /*  get('/search_unit?q='+this.search) */
        .then((response) => {
          if (this.search != "") {
            this.listes_service.data = response.data.Fact;
          }
        });
    }),
    all_imprimer() {
      axios
        .post(
          `${apiDomain}/api/del2/` + this.idsImprimer
        ) /* + this.idsImprimer */
        .then((response) => {
          this.facture_ser_okba_paye();
          this.idsImprimer = [];
          this.all_select == true
            ? (this.all_select = false)
            : (this.all_select = true);
        });
    },
    select_all_via_check_box() {
      if (this.all_select == false) {
        this.all_select = true;
        this.listes_service.forEach((user) => {
          this.idsImprimer.push(user.id);
        });
      } else {
        this.all_select = false;
        this.idsImprimer = [];
      }
    },

    updatedPaye_all(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_all/${this.idsImprimer}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.facture_ser_okba_paye();
        })

        .catch((err) => console.log(err));
    },

    updatedPaye(id) {
      fetch(`${apiDomain}/api/UpdatedPayement/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.facture_ser_okba_paye();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente_all(id) {
      fetch(
        `${apiDomain}/api/UpdatedPayement_EN_attente_all/${this.idsImprimer}`,
        {
          method: "post",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.facture_ser_okba_paye();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_EN_attente/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.facture_ser_okba_paye();
        })

        .catch((err) => console.log(err));
    },

    delete_service(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");

          this.facture_ser_okba_paye();
        })

        .catch((err) => console.log(err));
      }
    },
    facture_ser_okba_paye____() {
      fetch(`${apiDomain}/api/get_facture`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service;
        })
        .catch((err) => console.log(err));
    },

    getResults(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      let vm = this;
      fetch(`${apiDomain}/api/get_facture?page=` + page)
        .then((res) => res.json())
        .then((data) => {
          this.listes_service = data.all_service;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */

.non_paye {
  position: absolute;
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /* margin-top: -15.6%; */
  margin-top: 1.4% !important;
  height: 34px;
  line-height: 9px;
  border-radius: 15px;
}

.paye {
  position: absolute;
  background: #28e40c;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: -16.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.en_attente {
  position: absolute;
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*   margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

nav {
  display: flex;
  justify-content: center;
}

.pagination {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.pagination li {
  margin: 0 1px;
  padding: 11px 6px !important;
  text-decoration: none;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #2a357d !important;

  color: #ffffff !important;
  -webkit-box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
  box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
}

.pagination > li > a,
.pagination > li > span {
  color: fff;
  list-style-type: cercle;
  border: 0;
  border-radius: -16px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: 9px;
  margin: 0 3px;
  min-width: 31px;
  height: 31px;
  line-height: 30px;
  color: #999999;
  font-weight: 400;
  font-size: 11px;
  text-transform: uppercase;
  background: transparent;
  /* border-color: blue !important; */
  border-radius: 4px;
  background-color: #e88e08 !important;
  /* border-color: #000; */
  color: #fff !important;
}

.index {
  display: inline-block;
  height: 36px;
  width: 36px;
  line-height: 36px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cer {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: rgb(245 175 19);
}
.cer_green {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: #0ef717;
}
</style>

